module.exports = __webpack_public_path__ + "img/boissons.1f59ab84.svg";